import { makeStyles } from '@material-ui/core/styles';
import { DisabledVariant } from './index';

type CheckboxFieldProps = {
  disabledVariant: DisabledVariant;
  bordered: boolean;
};

export const useStyles = makeStyles(() => ({
  input: {
    color: '#2D2D2D',
    padding: '16.5px 15px',
    background: '#fff',
    border: ({ bordered }: CheckboxFieldProps) => (bordered ? `1px solid #ABAFB3` : 'unset'),
  },
  label: {
    display: 'flex',
    fontSize: 18,
    fontWeight: 300,
    lineHeight: '30px',
    color: '#000',
    paddingBottom: '5px',
  },
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
  disabled: {
    borderRadius: '10px',
    backgroundColor: ({ disabledVariant }: CheckboxFieldProps) => (disabledVariant === 'grey' ? '#C5C5C5' : 'unset'),
  },
}));
